import { UntitledIcon } from '@faceup/icons'
import type { ReactNode } from 'react'
import { ucDots2Grid } from '../customIcons'

type SimpleDragListItemProps = {
  isDraggable: boolean
  /**
   * Used when nested drag lists need to be distinguished.
   */
  identifier?: string
  children: ReactNode
}

export const SimpleDragListItem = (props: SimpleDragListItemProps) => {
  const { isDraggable, children, identifier = '' } = props
  return (
    <div className={identifier ? `${identifier}-item` : undefined}>
      <div className='flex w-full gap-2'>
        <div
          className={isDraggable ? `draggable ${identifier}` : ''}
          style={{
            cursor: isDraggable ? 'move' : undefined,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              pointerEvents: 'none',
              opacity: isDraggable ? 1 : 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <UntitledIcon icon={ucDots2Grid} size={20} color='#6F91B7' />
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
